import { useUserStore } from '@/store/user';
import { EditField } from '../components/EditField';
import i18n from '@/localisation/i18n';

export const Email = () => {
  const { email } = useUserStore();

  return (
    <>
      <div className="my-3 md:my-5">
        <div className="text-base text-additional">Email</div>
        <div className="text-xs text-additional">{i18n.t('not.shown')}</div>
        <EditField
          isEditing={false}
          name={email}
          updatedName={email}
          setUpdatedName={() => {}}
        />
      </div>
      <div className="divider"></div>
    </>
  );
};
